export function isAuthDebugEnabled() {
  return import.meta.env.DEV && import.meta.env.VITE_DEBUG_AUTH === 'true';
}
